/**
 * Apply page-specific theme (e.g. from page metadata) without persisting to localStorage.
 * Use for page view only; dashboard and user preference should use initializeDarkModeToggle(null).
 */
export function applyPageTheme(isDark) {
    document.body.classList.toggle('dark-mode', isDark);
    document.documentElement.classList.toggle('dark', isDark);
    const darkModeToggle = document.getElementById('darkModeEnabled');
    if (darkModeToggle) {
        darkModeToggle.checked = isDark;
    }
}

export function initializeDarkModeToggle(metadataPreference = null, options = {}) {
    const darkModeToggle = document.getElementById('darkModeEnabled');
    const { persist = (metadataPreference === null) } = options;

    const isMochinesPage = (
        window.location.href.includes('m-o-c-h-i-n-e-s') &&
        (window.location.href.includes('sp1zcyg0d3hck2f7sy8vh9zreb0jwcbsapfns8v5z') ||
            window.location.href.includes('sp327amyaajfhdsdge6ad0htacyq4ccxjgt47m2h3'))
    );

    // If it's Mochines page, force dark mode (page-only, do not persist)
    if (isMochinesPage) {
        updateDarkMode(true, { persist: false });
        if (darkModeToggle) {
            darkModeToggle.checked = true;
            darkModeToggle.disabled = true; // Optional: prevent toggling on Mochines page
        }
        return; // Exit early for Mochines page
    }

    // If we have a metadata preference, use it instead of localStorage
    const prefersDarkMode = metadataPreference !== null
        ? metadataPreference
        : localStorage.getItem('darkMode') === 'true';

    console.log('Dark mode preference:', prefersDarkMode,
        metadataPreference !== null ? '(from metadata)' : '(from localStorage)');
    console.log('Dark mode persistence:', persist ? 'enabled' : 'disabled');

    console.log('Dark mode toggle element:', darkModeToggle);

    if (darkModeToggle) {
        darkModeToggle.checked = prefersDarkMode;
        darkModeToggle.disabled = false;
        updateDarkMode(prefersDarkMode, { persist });
        console.log('Dark mode toggle initialized:', prefersDarkMode);

        // Keep the rest of the function the same
        darkModeToggle.addEventListener('change', (e) => {
            const isDark = e.target.checked;
            console.log('Dark mode toggle changed:', isDark);
            updateDarkMode(isDark, { persist });
        });
    } else {
        // Even without a toggle element, we still want to apply the dark mode
        updateDarkMode(prefersDarkMode, { persist });
    }
}
function updateDarkMode(isDark, options = {}) {
    const { persist = true } = options;
    console.log("updateDarkMode called with isDark:", isDark, "persist:", persist);

    // Apply theme to both body and html so dashboard and page views stay in sync when restoring
    document.body.classList.toggle('dark-mode', isDark);
    document.documentElement.classList.toggle('dark', isDark);
    if (persist) {
        localStorage.setItem('darkMode', isDark);
    }

    // Move function definition before the call
    function updateEditableBlocks(isDark) {
        console.log("updateEditableBlocks called with isDark:", isDark);
        console.log("Number of editable blocks found:", document.querySelectorAll('.editable-block').length);

        // Update all editable blocks to match the current mode
        const editableBlocks = document.querySelectorAll('.editable-block');

        editableBlocks.forEach(block => {
            console.log("Processing block:", block.getAttribute('data-type'));
            // Reset to CSS variable values by removing inline styles
            block.style.backgroundColor = '';
            block.style.color = '';
            block.style.border = '';

            // For specific block types that need special handling
            if (block.getAttribute('data-type') === 'heading') {
                console.log("Applying heading styles");
                // Let CSS variables handle it
            } else if (block.getAttribute('data-type') === 'paragraph') {
                console.log("Applying paragraph styles");
                // Let CSS variables handle it
            } else if (block.getAttribute('data-type') === 'image') {
                console.log("Applying image styles");
                // Image blocks might need special handling
                block.style.border = isDark ? '1px solid #444' : '1px solid #ddd';
            }
        });
    }

    // Now call the function after it's defined
    updateEditableBlocks(isDark);

    // Additional Mochines-specific styles that might not be covered by CSS variables
    if (window.location.href.includes('m-o-c-h-i-n-e-s')) {
        console.log("Applying Mochines-specific styles");
        const nftGrid = document.querySelector('.nft-collection-grid');
        if (nftGrid) {
            nftGrid.style.backgroundColor = isDark ? '#1a1a1a' : '';
        }

        const nftPreviews = document.querySelectorAll('.nft-preview');
        nftPreviews.forEach(preview => {
            preview.style.border = isDark ? '1px solid #333' : '';
            preview.style.backgroundColor = isDark ? '#1a1a1a' : '';
        });
    }
}